import React, { createContext, useContext, useState, ReactNode } from "react";
import { MetricGroup } from "../AssetDashboard/CardAssets/MetricConfig_type";

interface AssetContextType {
  resourceNames: string[];
  setResourceNames: (names: string[]) => void;
  selectedAsset: any;
  setSelectedAsset: (asset: any) => void;
  selectedAssetNameContext: any;
  setSelectedAssetNameContext: (asset: any) => void;
  revenueData: any[];
  setRevenueData: (data: any[]) => void;
  activeTabLabel: string;
  setActiveTabLabel: (label: string) => void;
  allRevenueData: any[];
  setAllRevenueData: (data: any[]) => void;
  volumeData: any[];
  setVolumeData: (data: any[]) => void;
  allVolumeData: any[];
  setAllVolumeData: (data: any[]) => void;
  allPricingData: any[];
  setAllPricingData: (data: any[]) => void;
  allVolumeDeltaData: any[];
  setAllVolumeDeltaData: (data: any[]) => void;
  allTotalCycleData: any[];
  setAllTotalCycleData: (data: any[]) => void;
  allTotalEnergyData: any[];
  setAllTotalEnergyData: (data: any[]) => void;
  allNetMwData: any[];
  setAllNetMwData: (data: any[]) => void;
  pricingData: any[];
  resetFilters: () => void;
  setPricingData: (data: any[]) => void;
  VolumeDeltaData: any[];
  setVolumeDeltaData: (data: any[]) => void;
  Net_Mw_Data: any[];
  setNet_Mw_Data: (data: any[]) => void;
  revenueMetrics: string[];
  setRevenueMetrics: (metrics: string[]) => void;
  volumeMetrics: string[];
  setVolumeMetrics: (metrics: string[]) => void;
  pricingMetrics: string[];
  setPricingMetrics: (metrics: string[]) => void;
  VolumeDeltaMetrics: string[];
  setVolumeDeltaMetrics: (metrics: string[]) => void;
  GroupByrevenueMetrics: string[];
  Net_Mw_Metrics: string[];
  setNet_Mw_Metrics: (metrics: string[]) => void;
  GroupBysetRevenueMetrics: (metrics: string[]) => void;
  GroupByvolumeMetrics: string[];
  GroupBysetVolumeMetrics: (metrics: string[]) => void;
  GroupBypricingMetrics: string[];
  GroupBysetPricingMetrics: (metrics: string[]) => void;
  GroupByVolumeDeltaMetrics: string[];
  GroupBysetVolumeDeltaMetrics: (metrics: string[]) => void;
  GroupByResourceMetrics: string[];
  GroupBysetResourceMetrics: (metrics: string[]) => void;
  selectedResource: string;
  setSelectedResource: (resource: string) => void;
  selectedDateRange: string;
  setSelectedDateRange: (dateRange: string) => void;
  selectedFrequency: string;
  setSelectedFrequency: (frequency: string) => void;
  startDate: string | null;
  setStartDate: (string: string | null) => void;
  endDate: string | null;
  setEndDate: (string: string | null) => void;
  selectedRevenue: string;
  setSelectedRevenue: (frequency: string) => void;
  revenueAsset: any;
  setRevenueAsset: (asset: any) => void;
  volumeAsset: any;
  setVolumeAsset: (asset: any) => void;
  pricingAsset: any;
  setPricingAsset: (asset: any) => void;
  VolumeDeltaAsset: any;
  setVolumeDeltaAsset: (asset: any) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isvolumeLoading: boolean;
  setIsvolumeLoading: (loading: boolean) => void;
  ispriceLoading: boolean;
  setIspriceLoading: (loading: boolean) => void;
  isDeltaLoading: boolean;
  setIsDeltaLoading: (loading: boolean) => void;
  isTotalenergyLoading: boolean;
  setIsTotalenergyLoading: (loading: boolean) => void;
  isTotalcycleLoading: boolean;
  setIsTotalcycleLoading: (loading: boolean) => void;
  selectedResources: { [assetId: string]: string };
  setSelectedResourceForAsset: (assetId: string, resource: string) => void;
  selectedAssetId: number | null;
  setSelectedAssetId: (id: number | null) => void;
  useIntervalAggregation: boolean;
  setUseIntervalAggregation: (value: boolean) => void;
  intervalAlignment: "beginning" | "industry" | "ending";
  setIntervalAlignment: (value: "beginning" | "industry" | "ending") => void;
  searchTrigger: number;
  triggerSearch: () => void;
  apiError: { [key: string]: string | null };
  setApiError: (errors: { [key: string]: string | null }) => void;
  volumeapiError: { [key: string]: string | null };
  setvolumeApiError: (errors: { [key: string]: string | null }) => void;
  priceapiError: { [key: string]: string | null };
  setpriceApiError: (errors: { [key: string]: string | null }) => void;
  DeltaApiError: { [key: string]: string | null };
  setDeltaApiError: (errors: { [key: string]: string | null }) => void;
  selectedMeasures: string[];
  setSelectedMeasures: (measures: string[]) => void;
  groupedPricingAsset: any;
  setGroupedPricingDataAsset: (asset: any) => void;
  metadata: any;
  setMetadata: (data: any) => void;
  groupedVolumeDataAsset: any;
  setGroupedVolumeDataAsset: (asset: any) => void;
  availableAssets: {
    asset_id: number;
    asset_name: string;
    asset_type: string;
    iso_code: string;
  }[];
  setAvailableAssets: (
    assets: {
      asset_id: number;
      asset_name: string;
      asset_type: string;
      iso_code: string;
    }[]
  ) => void;
  metricConfigData: MetricGroup[];
  setMetricConfigData: React.Dispatch<React.SetStateAction<MetricGroup[]>>;
}

const AssetContext = createContext<AssetContextType | undefined>(undefined);

export const AssetProvider = ({ children }: { children: ReactNode }) => {
  const [resourceNames, setResourceNames] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isvolumeLoading, setIsvolumeLoading] = useState<boolean>(false);
  const [ispriceLoading, setIspriceLoading] = useState<boolean>(false);
  const [isDeltaLoading, setIsDeltaLoading] = useState<boolean>(false);
  const [activeTabLabel, setActiveTabLabel] = useState<string>("");
  const [isTotalenergyLoading, setIsTotalenergyLoading] =
    useState<boolean>(false);
  const [isTotalcycleLoading, setIsTotalcycleLoading] =
    useState<boolean>(false);
  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [selectedAssetNameContext, setSelectedAssetNameContext] =
    useState<any>(null);
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);
  const [useIntervalAggregation, setUseIntervalAggregation] = useState(false);
  const [intervalAlignment, setIntervalAlignment] = useState<"beginning" | "industry" | "ending">("industry");
  const [searchTrigger, setSearchTrigger] = useState(0);
  const triggerSearch = () => setSearchTrigger((n) => n + 1);
  const [apiError, setApiError] = useState<{ [key: string]: string | null }>(
    {}
  );
  const [volumeapiError, setvolumeApiError] = useState<{
    [key: string]: string | null;
  }>({});
  const [priceapiError, setpriceApiError] = useState<{
    [key: string]: string | null;
  }>({});
  const [DeltaApiError, setDeltaApiError] = useState<{
    [key: string]: string | null;
  }>({});
  const [selectedMeasures, setSelectedMeasures] = useState<string[]>([]);
  const [groupedPricingAsset, setGroupedPricingDataAsset] = useState<
    any | null
  >(null);
  const [groupedVolumeDataAsset, setGroupedVolumeDataAsset] = useState<
    any | null
  >(null);
  const [availableAssets, setAvailableAssets] = useState<
    {
      asset_id: number;
      asset_name: string;
      asset_type: string;
      iso_code: string;
    }[]
  >([]);
  const [metricConfigData, setMetricConfigData] = useState<MetricGroup[]>([]);

  // Data states
  const [revenueData, setRevenueData] = useState<any[]>([]);
  const [allRevenueData, setAllRevenueData] = useState<any[]>([]);
  const [volumeData, setVolumeData] = useState<any[]>([]);
  const [pricingData, setPricingData] = useState<any[]>([]);
  const [VolumeDeltaData, setVolumeDeltaData] = useState<any[]>([]);
  const [Net_Mw_Data, setNet_Mw_Data] = useState<any[]>([]);
  const [allNetMwData, setAllNetMwData] = useState<any[]>([]);
  const [allVolumeData, setAllVolumeData] = useState<any[]>([]);
  const [allPricingData, setAllPricingData] = useState<any[]>([]);
  const [allVolumeDeltaData, setAllVolumeDeltaData] = useState<any[]>([]);
  const [allTotalCycleData, setAllTotalCycleData] = useState<any[]>([]);
  const [allTotalEnergyData, setAllTotalEnergyData] = useState<any[]>([]);
  // Separate Metrics
  const [revenueMetrics, setRevenueMetrics] = useState<string[]>([]);
  const [volumeMetrics, setVolumeMetrics] = useState<string[]>([]);
  const [pricingMetrics, setPricingMetrics] = useState<string[]>([]);
  const [VolumeDeltaMetrics, setVolumeDeltaMetrics] = useState<string[]>([]);
  const [Net_Mw_Metrics, setNet_Mw_Metrics] = useState<string[]>([]);

  const [GroupByrevenueMetrics, GroupBysetRevenueMetrics] = useState<string[]>(
    []
  );
  const [GroupByvolumeMetrics, GroupBysetVolumeMetrics] = useState<string[]>(
    []
  );
  const [GroupBypricingMetrics, GroupBysetPricingMetrics] = useState<string[]>(
    []
  );
  const [GroupByVolumeDeltaMetrics, GroupBysetVolumeDeltaMetrics] = useState<
    string[]
  >([]);

  // Other selection states
  const [selectedResource, setSelectedResource] = useState<string>("ALL");
  const [GroupByResourceMetrics, GroupBysetResourceMetrics] = useState<
    string[]
  >([]);
  const [selectedDateRange, setSelectedDateRange] =
    useState<string>("yesterday");
  const [selectedFrequency, setSelectedFrequency] = useState<string>("hour");
  const [selectedRevenue, setSelectedRevenue] = useState<string>("total");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  // Asset-specific states
  const [revenueAsset, setRevenueAsset] = useState<any | null>(null);
  const [pricingAsset, setPricingAsset] = useState<any | null>(null);
  const [volumeAsset, setVolumeAsset] = useState<any | null>(null);
  const [VolumeDeltaAsset, setVolumeDeltaAsset] = useState<any | null>(null);

  const [selectedResources, setSelectedResources] = useState<{
    [assetId: string]: string;
  }>({});
  // const [metadata, setMetadata] = useState<any>(null);
  const [metadata, setMetadata] = useState<any>({});
  const setSelectedResourceForAsset = (assetId: string, resource: string) => {
    setSelectedResources((prev) => ({
      ...prev,
      [assetId]: resource,
    }));
  };
 
  const resetFilters = () => {
    setSelectedDateRange("yesterday");
    setSelectedFrequency("hour");
    setSelectedResource("ALL");
    setSelectedRevenue("total");
    setStartDate(null);
    setEndDate(null);
    setResourceNames([]);

    setSelectedAsset(null);
    setSelectedAssetId(null);
    setSelectedAssetNameContext(null);
    setSelectedResources({});
    setSelectedMeasures([]);

    setIsLoading(false);
    setIsvolumeLoading(false);
    setIspriceLoading(false);
    setIsDeltaLoading(false);
    setIsTotalenergyLoading(false);
    setIsTotalcycleLoading(false);

    setApiError({});
    setvolumeApiError({});
    setpriceApiError({});
    setDeltaApiError({});
  };

  return (
    <AssetContext.Provider
      value={{
        availableAssets,
        setAvailableAssets,
        selectedAsset,
        setSelectedAsset,
        selectedAssetNameContext,
        setSelectedAssetNameContext,
        revenueData,
        allRevenueData,
        setAllRevenueData,
        allVolumeData,
        resetFilters ,
        setAllVolumeData,
        allVolumeDeltaData,
        setAllVolumeDeltaData,
        activeTabLabel,
        setActiveTabLabel,
        allPricingData,
        setAllPricingData,
        allTotalCycleData,
        setAllTotalCycleData,
        allTotalEnergyData,
        setAllTotalEnergyData,
        setAllNetMwData,
        allNetMwData,
        setRevenueData,
        revenueMetrics,
        setRevenueMetrics,
        volumeData,
        setVolumeData,
        volumeMetrics,
        setVolumeMetrics,
        pricingData,
        Net_Mw_Data,
        setNet_Mw_Data,
        setPricingData,
        pricingMetrics,
        setPricingMetrics,
        GroupByrevenueMetrics,
        GroupBysetRevenueMetrics,
        GroupByvolumeMetrics,
        GroupBysetVolumeMetrics,
        GroupBypricingMetrics,
        GroupBysetPricingMetrics,
        GroupByVolumeDeltaMetrics,
        GroupBysetVolumeDeltaMetrics,
        GroupByResourceMetrics,
        GroupBysetResourceMetrics,
        VolumeDeltaData,
        setVolumeDeltaData,
        VolumeDeltaMetrics,
        setVolumeDeltaMetrics,
        Net_Mw_Metrics,
        setNet_Mw_Metrics,
        selectedResource,
        setSelectedResource,
        selectedDateRange,
        setSelectedDateRange,
        selectedFrequency,
        setSelectedFrequency,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedRevenue,
        setSelectedRevenue,
        revenueAsset,
        setRevenueAsset,
        volumeAsset,
        setVolumeAsset,
        pricingAsset,
        setPricingAsset,
        VolumeDeltaAsset,
        setVolumeDeltaAsset,
        isLoading,
        setIsLoading,
        isTotalenergyLoading,
        setIsTotalenergyLoading,
        selectedResources,
        setSelectedResourceForAsset,
        selectedAssetId,
        setSelectedAssetId,
        useIntervalAggregation,
        setUseIntervalAggregation,
        intervalAlignment,
        setIntervalAlignment,
        searchTrigger,
        triggerSearch,
        resourceNames,
        setResourceNames,
        apiError,
        isvolumeLoading,
        setIsvolumeLoading,
        setApiError,
        volumeapiError,
        setvolumeApiError,
        priceapiError,
        setpriceApiError,
        ispriceLoading,
        setIspriceLoading,
        DeltaApiError,
        setDeltaApiError,
        isDeltaLoading,
        setIsDeltaLoading,
        isTotalcycleLoading,
        setIsTotalcycleLoading,
        selectedMeasures,
        setSelectedMeasures,
        groupedPricingAsset,
        setGroupedPricingDataAsset,
        groupedVolumeDataAsset,
        setGroupedVolumeDataAsset,
        metadata,
        setMetadata,
        metricConfigData,
        setMetricConfigData,
      }}
    >
      {children}
    </AssetContext.Provider>
  );
};

export const useAssetContext = () => {
  const context = useContext(AssetContext);
  if (!context) {
    throw new Error("useAssetContext must be used within an AssetProvider");
  }
  return context;
};
